// extracted by mini-css-extract-plugin
export default {"logoMercado":"Footer_logoMercado__Wbtu0","footerAbsolute":"Footer_footerAbsolute__CN9sL"};